import { LenderMap, LenderName, Product } from '@nemuru-eng/js-api-client';

import { AddAgentInLenderContextCredentialsFormType } from '@/components/modules/AgentDetail/ProvidersDetails/components/Credentials/components/AgentInLenderContextTable/schemas/AddAgentInLenderContextCredentialsFormSchema';

const isBbvaAuto = (lenderId: string, product: Product) =>
  LenderMap.fromLenderId(lenderId) === LenderName.BBVA && product === Product.AUTO;

export const getCredentialAuthPayloadFields = (formValues: AddAgentInLenderContextCredentialsFormType) => {
  if (isBbvaAuto(formValues.lenderId, formValues.product as Product)) {
    const clientId = formValues.clientId?.trim();
    const clientSecret = formValues.clientSecret?.trim();

    return {
      ...(clientId && { clientId, username: clientId }),
      ...(clientSecret && { clientSecret, password: clientSecret }),
    };
  }

  return {
    ...(formValues.username && { username: formValues.username.trim() }),
    ...(formValues.password && { password: formValues.password.trim() }),
    ...(formValues.clientId && { clientId: formValues.clientId.trim() }),
    ...(formValues.clientSecret && { clientSecret: formValues.clientSecret.trim() }),
  };
};
